export default __webpack_public_path__ + "static/media/720px-Sunset-Title-PMR-light-border.2b24c0d9.webp";